import { IMessageResponse } from '../../../interfaces/api/IQueries';
import { IGetStoresResponse, IPostStoresUploadQuery, IPostStoresUploadResponse } from '../../../interfaces/api/IStores';
import {api} from '../api';

/**
 * it adds the stores endpoint to the api
 * 
 * @returns StoresRepository
 */
const StoresRepository = api.injectEndpoints({
    endpoints: (build) => ({
        getStores: build.query<IGetStoresResponse, void>({
            query: () => ({url: "/stores", method: "GET"}),          
        }),
        postStoresUpload: build.mutation<IPostStoresUploadResponse|IMessageResponse, IPostStoresUploadQuery>({
            query: (data) => ({url: "/stores/upload", method: "POST", data}),
        }),
    }),
});

export const { useGetStoresQuery, usePostStoresUploadMutation } = StoresRepository;